const config = {
  // REQUIRED
  appName: "Peeqback",
  // REQUIRED: a short description of your app for SEO tags (can be overwritten)
  appDescription:
    "Peeqback is a user feedback management platform for product teams. Collect feature requests via an embeddable widget, prioritize with a public voting board, track work on a product roadmap, and keep users informed with a changelog.",
  // REQUIRED (no https://, not trialing slash at the end, just the naked domain)
  domainName: "peeqback.com",
  crisp: {
    // Crisp website ID. IF YOU DON'T USE CRISP: just remove this => Then add a support email in this config file (resend.supportEmail) otherwise customer support won't work.
    id: "",
    // Hide Crisp by default, except on route "/". Crisp is toggled with <ButtonSupport/>. If you want to show Crisp on every routes, just remove this below
    onlyShowOnRoutes: ["/"],
  },
  lemonsqueezy: {
    // 3 plans × 2 billing periods = 6 variants.
    // Replace the placeholder variantIds below with the real ones from your LemonSqueezy dashboard.
    // For each plan, create two variants: one monthly, one yearly (set the trial period to 14 days on each variant in the LemonSqueezy dashboard).
    plans: [
      {
        name: "Starter" as const,
        description: "For indie makers and early-stage startups getting started with user feedback.",
        monthlyPrice: 19,
        yearlyPrice: 15, // $182/yr (≈20% off)
        yearlyTotal: 182,
        monthly: {
          variantId: (process.env.NEXT_PUBLIC_LEMON_SQUEEZY_STARTER_MONTHLY_VARIANT_ID ?? process.env.LEMON_SQUEEZY_STARTER_MONTHLY_VARIANT_ID ?? "").trim(),
        },
        yearly: {
          variantId: (process.env.NEXT_PUBLIC_LEMON_SQUEEZY_STARTER_YEARLY_VARIANT_ID ?? process.env.LEMON_SQUEEZY_STARTER_YEARLY_VARIANT_ID ?? "").trim(),
        },
        features: [
          { name: "1 project" },
          { name: "3 feedback boards" },
          { name: "Up to 3 team members" },
          { name: "Public roadmap & changelog" },
          { name: "Email notifications" },
          { name: "14-day free trial", highlight: true },
        ],
      },
      {
        name: "Growth" as const,
        isFeatured: true,
        description: "For growing product teams that need more power, integrations, and collaboration.",
        monthlyPrice: 49,
        yearlyPrice: 39, // $470/yr (≈20% off)
        yearlyTotal: 470,
        monthly: {
          variantId: (process.env.NEXT_PUBLIC_LEMON_SQUEEZY_GROWTH_MONTHLY_VARIANT_ID ?? process.env.LEMON_SQUEEZY_GROWTH_MONTHLY_VARIANT_ID ?? "").trim(),
        },
        yearly: {
          variantId: (process.env.NEXT_PUBLIC_LEMON_SQUEEZY_GROWTH_YEARLY_VARIANT_ID ?? process.env.LEMON_SQUEEZY_GROWTH_YEARLY_VARIANT_ID ?? "").trim(),
        },
        features: [
          { name: "Up to 5 projects" },
          { name: "10 feedback boards" },
          { name: "Up to 10 team members" },
          { name: "Public roadmap & changelog" },
          { name: "Slack & Discord integrations" },
          { name: "CSV export" },
          { name: "Priority support" },
          { name: "14-day free trial", highlight: true },
        ],
      },
      {
        name: "Pro" as const,
        description: "For scaling companies that need unlimited everything and white-label options.",
        monthlyPrice: 99,
        yearlyPrice: 79, // $950/yr (≈20% off)
        yearlyTotal: 950,
        monthly: {
          variantId: (process.env.NEXT_PUBLIC_LEMON_SQUEEZY_PRO_MONTHLY_VARIANT_ID ?? process.env.LEMON_SQUEEZY_PRO_MONTHLY_VARIANT_ID ?? "").trim(),
        },
        yearly: {
          variantId: (process.env.NEXT_PUBLIC_LEMON_SQUEEZY_PRO_YEARLY_VARIANT_ID ?? process.env.LEMON_SQUEEZY_PRO_YEARLY_VARIANT_ID ?? "").trim(),
        },
        features: [
          { name: "Unlimited projects" },
          { name: "Unlimited feedback boards" },
          { name: "Unlimited team members" },
          { name: "Public roadmap & changelog" },
          { name: "Slack, Discord & Zapier integrations" },
          { name: "CSV export" },
          { name: "Remove 'Powered by Peeqback' branding" },
          { name: "14-day free trial", highlight: true },
        ],
      },
    ],
  },
  aws: {
    // If you use AWS S3/Cloudfront, put values in here
    bucket: "bucket-name",
    bucketUrl: `https://bucket-name.s3.amazonaws.com/`,
    cdn: "https://cdn-id.cloudfront.net/",
  },
  resend: {
    // REQUIRED — Email 'From' field to be used when sending magic login links
    fromNoReply: `Peeqback <noreply@resend.peeqback.com>`,
    // REQUIRED — Email 'From' field to be used when sending other emails, like abandoned carts, updates etc..
    fromAdmin: `Jay from Peeqback <hello@updates.peeqback.com>`,
    // Email shown to customer if need support. Leave empty if not needed => if empty, set up Crisp above, otherwise you won't be able to offer customer support."
    supportEmail: "support@peeqback.com",
  },
  colors: {
    // REQUIRED — This color will be reflected on the whole app outside of the document (loading bar, Chrome tabs, etc..). 
    // You can use a custom color: main: "#f37055". HEX only.
    main: "#222.2 47.4% 11.2%",
    // Shared heading/title color used across the marketing and auth UI.
    heading: "#262626",
    // Global light-mode app background.
    background: "#F3F4F6",
  },
  auth: {
    // REQUIRED — the path to log in users. It's use to protect private routes (like /dashboard). It's used in apiClient (/libs/api.js) upon 401 errors from our API
    loginUrl: "/api/auth/signin",
    // REQUIRED — the path you want to redirect users after successfull login (i.e. /dashboard, /private). This is normally a private page for users to manage their accounts. It's used in apiClient (/libs/api.js) upon 401 errors from our API & in ButtonSignin.js
    callbackUrl: "/dashboard",
  },
};

export default config;
